import Vue from 'vue';
import { ServiceRequestNewForm } from './ServiceRequestNewForm';
import state from './state';
import { extend, getAbilityPromise } from '~/defineAbility';
import { applySpec, prop } from 'ramda';

const clientAdapter = applySpec({
	name: prop('name'),
	phone: prop('number'),
});

document.addEventListener('DOMContentLoaded', async () => {
	const mountPoint = document.querySelector('#clientRequest');

	if (!mountPoint) return;

	const { __INITIAL_STATE__: initialState } = BX;
	const { isAdministrator, client } = initialState.request;

	await getAbilityPromise;

	extend('service', [
		{ action: "update", subject: "ServiceRequest" },
		{ action: "create", subject: "HiddenRepair" },
		{ action: "update", subject: "ServiceRequest", field: "SERVICE_ID", inverted: !isAdministrator },
		{ action: "update", subject: "HiddenRepair", inverted: !isAdministrator },
	])

	const form = new Vue(ServiceRequestNewForm);

	form.client = clientAdapter(client);

	if (initialState.request)
		Vue.set(state, 'request', initialState.request);

	form.$mount(mountPoint);
});
